import { GET_INTERNATIONAL_STYLE_REQUEST, GET_INTERNATIONAL_STYLE_SUCCESS, GET_INTERNATIONAL_STYLE_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalStyle = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_STYLE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalStyle`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_STYLE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_STYLE_ERROR,
                payload: error.response,
            });
        })
}

